import {
    useCallback,
} from 'react'
import {
    useQuery,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import {
    RequestKeys,
} from 'app/hooks/useRequest'
import simpleApi from 'app/services/simpleApi'
import requests from 'app/requests/Attachment.requests'
import AttachmentType from '../Attachment.types'

const useGetFiles = (value?: AttachmentType[] | number[]) => {
    const token = useJWTToken()
    const queryFn = useCallback(() => {
        return simpleApi({
            ...requests.filterRequest({
                ids: value,
            }),
            token,
        })
    }, [
        token,
        value,
    ])

    return useQuery({
        queryKey: [
            RequestKeys.getAttachments,
            value,
        ],
        queryFn,
        enabled: Boolean(value),
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 1000,
        refetchInterval: false,
    })
}

export default useGetFiles
